<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-01 14:23:43
 * @Description: 官网首页
 -->

<template>
  <div class="bank-wrapper">
    <img src="https://files.jinr.com/jinr-index/img/bank-content-01.png" alt="" srcset="" />
    <img src="https://files.jinr.com/jinr-index/img/bank-content-02.png" alt="" srcset="" />
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.bank-wrapper {
  padding: 40px 0 0;
  img {
    width: 100%;
    margin: 40px 0 0;
  }
}
</style>
